import "./App.scss";
import { Outlet } from "react-router";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Disclaimer from "./components/Disclaimer";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <Header />
      <Outlet />
      <Disclaimer />
      <Footer />
      <ToastContainer />
    </div>
  );
}

export default App;
